import { Box, BoxProps, List, Stack } from '@mui/material';
import { FunctionComponent } from 'react';
import { NavItem, NavItemProps } from '../nav-item';

export type NavSectionProps = {
  isItemSelected: (item: NavItemProps) => boolean;
  items: NavItemProps[];
} & BoxProps;

export const NavSection: FunctionComponent<NavSectionProps> = (props) => {
  const { isItemSelected, items, ...boxProps } = props;
  return (
    <Box {...boxProps}>
      <List sx={{ p: 1 }}>
        <Stack direction="column" spacing={0.5}>
          {items.map((item, index) => (
            <NavItem key={index} selected={isItemSelected(item)} {...item} />
          ))}
        </Stack>
      </List>
    </Box>
  );
};
